// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Group, Center } from '@/components/ui/layout';
import { Title, Text, Button, Anchor } from '@/components/ui/core';
import { TextInput, PasswordInput, Checkbox } from '@/components/ui/inputs';
import { Divider } from '@/components/ui/data-display';
import { IconMail, IconLock, IconArrowLeft } from '@tabler/icons-react';
import { AuthLayoutWrapper } from '../components';
import { SocialLoginButtons } from '../components';

export default function LoginClassicMinimal() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Login attempt:', { email, password, rememberMe });
  };

  return (
    <AuthLayoutWrapper variant="simple">
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/demo/auth-pages/login"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to variants
        </Button>

        {/* Logo/Brand */}
        <Center>
          <Stack align="center" gap="xs">
            <Center
              style={(theme) => ({
                width: 48,
                height: 48,
                borderRadius: theme.radius.md,
                background: 'linear-gradient(135deg, var(--mantine-color-indigo-6), var(--mantine-color-cyan-5))',
              })}
            >
              <Text size="xl" fw={700} c="white">C</Text>
            </Center>
            <Title order={2} ta="center">Welcome back</Title>
            <Text c="dimmed" size="sm" ta="center">
              Sign in to your account to continue
            </Text>
          </Stack>
        </Center>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            <TextInput
              label="Email"
              placeholder="your@email.com"
              leftSection={<IconMail size={16} />}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <PasswordInput
              label="Password"
              placeholder="Your password"
              leftSection={<IconLock size={16} />}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <Group justify="space-between">
              <Checkbox
                label="Remember me"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.currentTarget.checked)}
              />
              <Anchor component={Link} to="/demo/auth-pages/forgot-password/simple" size="sm">
                Forgot password?
              </Anchor>
            </Group>

            <Button type="submit" fullWidth>
              Sign in
            </Button>
          </Stack>
        </form>

        {/* Social Login */}
        <SocialLoginButtons
          providers={['google', 'github']}
          layout="horizontal"
          variant="outline"
        />

        {/* Register Link */}
        <Text ta="center" size="sm">
          Don't have an account?{' '}
          <Anchor component={Link} to="/demo/auth-pages/register/simple" fw={500}>
            Sign up
          </Anchor>
        </Text>
      </Stack>
    </AuthLayoutWrapper>
  );
}
